import { featureFlagKeySchema } from "@redotech/feature-flags-model/schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setFeatureFlagArm = {
  name: "setFeatureFlagArm" as const,
  input: z.object({
    teamId: zExt.objectId(),
    flagKey: featureFlagKeySchema,
    value: z.boolean(),
    environmentKey: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
